import { render, staticRenderFns } from "./leftCategory.vue?vue&type=template&id=71351283&scoped=true"
import script from "./leftCategory.vue?vue&type=script&lang=js"
export * from "./leftCategory.vue?vue&type=script&lang=js"
import style0 from "./leftCategory.vue?vue&type=style&index=0&id=71351283&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71351283",
  null
  
)

export default component.exports